'use client'

import { useCallback, useRef } from 'react'
import { useRouter } from '@/lib/next-shim'

/**
 * Returns a stable navigator that performs `router.replace` at most once for the
 * lifetime of the component. Useful when several effects / handlers race to leave
 * for the same destination and `router` is a fresh object on every render.
 */
export function useNavigateOnce() {
  const router = useRouter()
  const navigatedRef = useRef(false)

  return useCallback(
    (url: string) => {
      if (navigatedRef.current) return
      navigatedRef.current = true
      router.replace(url)
    },
    [router]
  )
}
